export default "/_next/static/chunks/fonts/Raleway SemiBold-bd43d9472ee0c9fbe7855e9b4ab2df51.ttf";